export const DeleteConfirmationModal = ({ discountId, id, title, subtitle, onConfirm }) => {
    return (
        <div className={`modal ${discountId ? 'show' : ''}`}
            id={id}
            aria-hidden={true}
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss={"modal"}
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        {subtitle}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Cancel
                        </button>
                        <button type="button" className="btn btn-danger" onClick={onConfirm}>
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};